// This is just an example,
// so you can safely delete all default props below

export default {
    back: 'Back',
    title: 'Claims',
    create: 'Create',
    claim: 'Claim',
    new_claim: 'Create New Claim',
    claim_type: 'Claim Type',
    claim_value: 'Claim Value',
    delete: 'Delete',
    save: 'Save',
    create_child_claim: 'Create Childre Claim',
    create_child_claim_for: 'Create children claim for',
}
